import React from 'react';

const PrivacyPolicy = () => (
  <div className="p-6 max-w-3xl mx-auto text-gray-800">
    <h1 className="text-2xl font-bold mb-4">Privacy Policy for Tini Express Invoice Generator</h1>
    <p className="text-sm text-gray-600 mb-2">Last updated: May 5, 2025</p>

    <p className="mb-4">
      The Tini Express Invoice Generator (https://admin.tini-express.com) usees a Google Apps Script designed to generate invoices for Tini Express (https://tini-express.com) operations.
      This tool is part of an internal process and does not collect or process any personal information from users.
    </p>

    <h2 className="font-semibold mt-6 mb-2">1. Information Collection</h2>
    <p className="mb-4">The script does not collect, store, or transmit any personal or sensitive user data.</p>

    <h2 className="font-semibold mt-6 mb-2">2. Use of the Script</h2>
    <p className="mb-2">The script is used solely to generate invoices for Tini Express.</p>
    <ul className="list-disc list-inside mb-4">
      <li>It does not access user accounts or require authentication.</li>
      <li>It runs based on predefined templates and logic relevant only to Tini Express operations.</li>
    </ul>

    <h2 className="font-semibold mt-6 mb-2">3. Data Privacy</h2>
    <ul className="list-disc list-inside mb-4">
      <li>No user data is transmitted to external servers.</li>
      <li>The script operates entirely within the Google environment and does not interact with external services.</li>
      <li>No third parties are involved in processing or storing information.</li>
    </ul>

    <h2 className="font-semibold mt-6 mb-2">4. Public Accessibility</h2>
    <p className="mb-4">
      Although the script is accessible by anyone, it is intended for internal use.
      It performs a fixed function and does not adapt based on who runs it.
    </p>

    <h2 className="font-semibold mt-6 mb-2">5. Contact</h2>
    <p>If you have any questions or concerns, you may reach out to <a href="mailto:support@tini-express.com" className="text-blue-600 hover:underline">support@tini-express.com</a></p>
  </div>
);

export default PrivacyPolicy;
